import { inventoryAdjustmentReasonIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { inventoryAdjustmentReasonDirectionSchema } from "./direction";

export const updateInventoryAdjustmentReason = {
  name: "updateInventoryAdjustmentReason" as const,
  input: z.object({
    id: inventoryAdjustmentReasonIdFormat.schema,
    name: z.string().min(1),
    direction: inventoryAdjustmentReasonDirectionSchema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
